import { Star } from 'lucide-react'

import { cn } from '@/shared/lib/utils'

type TopRatedBadgeProps = {
  className?: string
  starClassName?: string
  topLabelClassName?: string
  ratedLabelClassName?: string
}

const TopRatedBadge = ({
  className,
  starClassName,
  topLabelClassName,
  ratedLabelClassName,
}: TopRatedBadgeProps) => {
  return (
    <div
      className={cn(
        'relative h-[48px] w-[25px] overflow-hidden rounded-[27px] bg-[linear-gradient(180deg,#001F5F_0%,#ECECEC_50%,#073491_100%)] text-center text-white',
        className,
      )}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-[2px] rounded-[inherit] bg-gradient-to-b from-[#1A5895] via-[#1F499A] via-50% to-[#111250]"
      />
      <div className="absolute left-0 top-[5px] z-10 flex w-6 flex-col items-center gap-[3px]">
        <div className="relative size-[17px] overflow-hidden">
          <Star
            className={cn(
              'absolute inset-0 size-[17px] fill-transparent stroke-[#E3B22D]',
              starClassName,
            )}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />

          <Star
            className="absolute left-[2.13px] top-px size-[3.54px] fill-[#FDC700] stroke-[#FDC700]"
            strokeWidth={1}
            aria-hidden
          />
          <Star
            className="absolute left-[11.69px] top-px size-[3.54px] fill-[#FDC700] stroke-[#FDC700]"
            strokeWidth={1}
            aria-hidden
          />
          <Star
            className="absolute left-[6.5px] top-[14px] size-[3.54px] fill-[#FDC700] stroke-[#FDC700]"
            strokeWidth={1}
            aria-hidden
          />
          <Star
            className="absolute left-[-0.36px] top-2.5 size-[3.54px] fill-[#FDC700] stroke-[#FDC700]"
            strokeWidth={1}
            aria-hidden
          />
          <Star
            className="absolute left-[13.81px] top-[9px] size-[3.54px] fill-[#FDC700] stroke-[#FDC700]"
            strokeWidth={1}
            aria-hidden
          />
        </div>

        <div className="w-full text-center font-semibold text-white">
          <p className={cn('mb-0 text-[8px] leading-[6px]', topLabelClassName)}>TOP</p>
          <p className={cn('text-[5px] leading-[6px]', ratedLabelClassName)}>RATED</p>
        </div>
      </div>
    </div>
  )
}

export default TopRatedBadge
